"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var NAME = 'block_quote';
var BlockQuote = /** @class */ (function (_super) {
    __extends(BlockQuote, _super);
    function BlockQuote() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'blockquote'; };
        _this.content = 'paragraph+';
        _this.textMatcher = [
            {
                matcher: [/^>\s$/, /^》\s$/]
            }
        ];
        _this.parseDOM = [{ tag: 'blockquote' }, { tag: 'bi' }];
        return _this;
    }
    return BlockQuote;
}(core_utilities_1.Block));
exports.BlockQuote = BlockQuote;
var BlockQuoteController = /** @class */ (function (_super) {
    __extends(BlockQuoteController, _super);
    function BlockQuoteController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'block_quote';
        _this.toolbar = {
            className: 'block_quote',
            tooltip: 'block_quote'
        };
        return _this;
    }
    return BlockQuoteController;
}(core_utilities_1.SylController));
var BlockQuotePlugin = /** @class */ (function (_super) {
    __extends(BlockQuotePlugin, _super);
    function BlockQuotePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = BlockQuoteController;
        _this.Schema = BlockQuote;
        return _this;
    }
    return BlockQuotePlugin;
}(core_utilities_1.SylPlugin));
exports.BlockQuotePlugin = BlockQuotePlugin;
//# sourceMappingURL=blockquote.js.map